import { Component, OnInit } from '@angular/core';
import {AbstractDisplayComponent} from '../abstract-display.component';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'dmp-boolean-display',
    templateUrl: './boolean-display.component.html',
    styleUrls: ['./boolean-display.component.scss'],
    standalone: false
})
export class BooleanDisplayComponent extends AbstractDisplayComponent implements OnInit {

    constructor(protected translate: TranslateService) {
        super();
    }

  ngOnInit(): void {
      this.displayHover = this.value;
      if ([true, 1, '1'].includes(this.value)) {
          this.display = this.translate.instant('common.True');
      } else if ([false, 0, '0'].includes(this.value)) {
          this.display = this.translate.instant('common.False');
      }
  }

}
